export const AuthActionsTypes = {
    LOGIN_SUCCESS:"LOGIN_SUCCESS",
    GET_USER_SUCCESS:"GET_USER_SUCCESS",
    GET_USER_FAILS:"GET_USER_FAILS",
    LOGOUT:"LOGOUT"
}